export const getRoleDisplayText = (role: string): string => {
  const roleText: Record<string, string> = {
    admin: "管理者",
    manager: "プロジェクト管理者",
    member: "ユーザー",
    guest: "ゲスト",
  };
  return roleText[role] || role;
};

export const getRolePriority = (role: string): number => {
  const rolePriority: Record<string, number> = {
    admin: 1,
    manager: 2,
    member: 3,
    guest: 4,
  };
  return rolePriority[role] || 99;
};
